import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanupHtml',
  standalone: true,
})
export class CleanupHtmlPipe implements PipeTransform {
  public transform(value: string) {
    const raw = value || '';
    return raw
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/<H[1-6]{1}>/gi, '<strong>')
      .replace(/<\/H[1-6]{1}>/gi, `</strong>\n`)
      .replace(/(\S.+)(\n|$)+/gim, '<p>$1</p>')
      .replace(/<br><p>/g, '<p>')
      .replace(/(?:\r\n|\r|\n|\u21b5)/g, '<br/> ');
  }
}
